'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by Administrator on 2016/8/5.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuccessModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(SuccessModal, _Component);

  function SuccessModal() {
    (0, _classCallCheck3.default)(this, SuccessModal);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(SuccessModal).call(this));
  }

  (0, _createClass3.default)(SuccessModal, [{
    key: 'render',
    value: function render() {
      var styles = require('./SuccessModal.scss');
      var _props = this.props;
      var onSubmit = _props.onSubmit;
      var text = _props.text;
      var isOpened = _props.isOpened;
      var width = _props.width;
      var children = _props.children;

      var widthStr = '80%';
      if (width && !isNaN(width)) {
        widthStr = width + 'px';
      }
      var customStyle = {
        content: {
          background: 'rgba(255, 255, 255, 0.8)',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '15px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: widthStr,
          maxWidth: '60rem'
        }
      };
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.submittedSucess },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/logo.png', alt: '' }),
          _react2.default.createElement(
            'p',
            { className: styles.submittedSucessTit },
            '艺品网提醒您'
          ),
          _react2.default.createElement(
            'p',
            { className: styles.submittedSucessContent },
            text
          ),
          _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            children
          ),
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bottom },
          _react2.default.createElement(
            'span',
            { className: styles.btn, onClick: function onClick() {
                return onSubmit ? onSubmit() : '';
              } },
            '确定'
          )
        )
      );
    }
  }]);
  return SuccessModal;
}(_react.Component), _class.propTypes = {
  isOpened: _react.PropTypes.bool,
  children: _react.PropTypes.object,
  text: _react.PropTypes.string,
  width: _react.PropTypes.string,
  onSubmit: _react.PropTypes.func
}, _temp);
exports.default = SuccessModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SuccessModal/SuccessModal.js
 ** module id = 1431
 ** module chunks = 0
 **/